module.exports = __webpack_public_path__ + "img/images_esg_2_3.f9a552fc.jpg";